import React from 'react';
import './Reviews.css';
import { HashLink } from 'react-router-hash-link';

interface Review {
  id: string;
  name: string;
  rating: number;
  text: string;
}

const Reviews: React.FC = () => {
  const reviews: Review[] = [
    {
      id: '1',
      name: 'Su S K',
      rating: 5,
      text: 'Emmanuel Ibenye, Lawyer/ Notary Public, provided outstanding service today. He handled the signing of our documents with efficiency, accuracy, and professionalism. I highly recommend his services to anyone in need of reliable legal or notary assistance.'
    },
    {
      id: '2',
      name: 'Karen Hibbard',
      rating: 5,
      text: 'Emmanuel was understanding and accommodating to my urgent request. He is easy to work with and reasonably priced'
    },
    {
      id: '3',
      name: 'marcus atencio',
      rating: 5,
      text: 'Very Professional and accommodating person. Highly recommended 👍🏽👍🏽'
    },
    {
      id: '4',
      name: 'Fernando Fukushima',
      rating: 5,
      text: 'Super easy and without any complications! Truly recommend!'
    },
    {
      id: '5',
      name: 'Tyler',
      rating: 5,
      text: 'Emmanuel was quick to help with my notarization and was super friendly and easy to work with! Highly recommend his services!'
    },
    {
      id: '6',
      name: 'Ahmad Mushtaq',
      rating: 5,
      text: 'Awesome service, great lawyer!'
    },
    {
      id: '7',
      name: 'Shahid Khan',
      rating: 5,
      text: 'Excellent and quick service at a reasonable price.'
    },
    {
      id: '8',
      name: 'Aniruddha Sawant',
      rating: 5,
      text: 'Emmanuel is really helpful and responds quickly. Thank you !'
    },
    {
      id: '9',
      name: 'Joseph Youssef',
      rating: 5,
      text: 'The service was very quick and affordable.'
    },
    {
      id: '10',
      name: 'Kalyan Veerabhotla',
      rating: 5,
      text: 'I called for services in the early morning and I received immediate response. Highly recommend his services'
    },
    {
      id: '11',
      name: 'Sheharbano Ali',
      rating: 5,
      text: 'Friendly, and professional, the process was a quick and easy one. Highly recommended for sure.'
    },
    {
      id: '12',
      name: 'Miss Mau De Vera',
      rating: 5,
      text: 'Fast and smooth notary service. Highly recommended!'
    },
    {
      id: '13',
      name: 'Mariah K',
      rating: 5,
      text: 'Kind and professional. Best price in the area!'
    },
    {
      id: '14',
      name: 'Jenn and Rj',
      rating: 5,
      text: 'Very responsive, great communication and available. I called at 10pm and everything notarized by 10:30pm'
    },
    {
      id: '15',
      name: 'Leena Q',
      rating: 5,
      text: 'Quick and smooth process. Appreciate his honesty and how straightforward the process was. Highly recommend!!'
    },
    {
      id: '16',
      name: 'Rana Khurram Manzoor',
      rating: 5,
      text: 'So smooth … very reasonable price'
    },
    {
      id: '17',
      name: 'Linto Thomas',
      rating: 5,
      text: 'Amazing POA attestation service with flexible hours. Extremely friendly and helpful experience.'
    },
    {
      id: '18',
      name: 'Zaeem ul Haq',
      rating: 5,
      text: 'Very professional and sociable. Highly recommended!'
    },
    {
      id: '19',
      name: 'mkhurramj',
      rating: 5,
      text: 'Best service'
    },
    {
      id: '20',
      name: 'Kathryn Oaken',
      rating: 5,
      text: 'Emmanuel gave us fast and same day service. So we were able to get on with our business faster than expected.'
    },
    {
      id: '21',
      name: 'Tiziana Turbian',
      rating: 5,
      text: 'Emanuel was truly so kind, efficient and professional. Highly recommended!'
    },
    {
      id: '22',
      name: 'Harpreet Kaur Dhaliwal',
      rating: 5,
      text: 'I went to get something notarized at around 11pm, I was very hesitant at first as Emmanuel works from home and because of the time of the day too. But he was extremely polite, kind accommodating and very helpful.'
    },
    {
      id: '23',
      name: 'Marco Scocco',
      rating: 5,
      text: 'Awesome guy to deal with. At first i was hesitant as he works from home. Hes very responsive and great price. Everytime i call him he answers the phone 😊 I highly recommend.'
    },
    {
      id: '24',
      name: 'Shannon Gunn',
      rating: 5,
      text: 'I was so impressed with how quickly and efficiently the process was! He was so friendly and welcoming. We will definitely recommend to others! Thanks again! :0)'
    },
    {
      id: '25',
      name: 'Utsav Kumar',
      rating: 5,
      text: 'Nice work!'
    },
    {
      id: '26',
      name: 'Asma Aftab',
      rating: 5,
      text: 'I found Emmanual to be extremely polite, professional, and efficient. He problem solved my situation for me and notarized my documents in an expedited manner. I have absolutely no hesitation in recommending him and would use his services again in future, if needed.'
    },
    {
      id: '27',
      name: 'Zakaria Alhabil',
      rating: 5,
      text: 'Emmanuel is very professional, his service is very convenient and his cost is very reasonable. His knowledge to draft documents and his agility to tailor the requirements was excellent.'
    },
    {
      id: '28',
      name: 'BOTHYNA TAHA',
      rating: 5,
      text: 'Very great service fast & good communication'
    },
    {
      id: '29',
      name: 'Umar Khan',
      rating: 5,
      text: 'Emmanuel helped me notarize a legal document and was incredibly helpful throughout the process. He provided valuable insight and answered all my questions. He was kind, understanding, and took his time to ensure everything went smoothly. Highly recommend his services!'
    },
    {
      id: '30',
      name: 'Van Yan',
      rating: 5,
      text: 'I highly recommended this place. Very knowledgeable and efficient. He was very nice to deal with. Thank you so much for your help.'
    },
    {
      id: '31',
      name: 'Sunil Minal',
      rating: 5,
      text: 'Emmanuel, is great professional person, very kind, amazing work, quick, on time and very calm & kind human being, 100% satisfaction guaranteed- I will recommend and I will do more work with him'
    },
    {
      id: '32',
      name: 'Akhil Kumar',
      rating: 5,
      text: 'I had a wonderful experience with Emmanuel. He was very quick in notarizing my document.'
    },
    {
      id: '33',
      name: 'Karim Elsherif',
      rating: 5,
      text: 'Professional, affordable and fast. I recommend him'
    },
    {
      id: '34',
      name: 'Jawad Rashid',
      rating: 5,
      text: 'He is professional and helpful. He helped me right away.'
    },
    {
      id: '35',
      name: 'Shawnette Sinclair',
      rating: 5,
      text: 'Highly recommended, he was efficient, smart and accommodating.'
    },
    {
      id: '36',
      name: 'Farrukh Aziz',
      rating: 5,
      text: 'Awesome experience. Very respectful and efficient'
    },
    {
      id: '37',
      name: 'Dominic Fonseka',
      rating: 5,
      text: 'Fast, good service. Will use again.'
    },
    {
      id: '38',
      name: 'shehzad Bhalli',
      rating: 5,
      text: 'Excellent timely service. Highly recommended'
    },
    {
      id: '39',
      name: 'Northern Light',
      rating: 5,
      text: 'Fast and smooth service Thanks Emanuel'
    },
    {
      id: '40',
      name: 'Fahad Ali Chaudhry',
      rating: 5,
      text: 'Quick service with great communication'
    },
    {
      id: '41',
      name: 'Adeaga Family',
      rating: 5,
      text: 'Professional. Polite and efficient service.'
    },
    {
      id: '42',
      name: 'flow prince',
      rating: 5,
      text: 'Excellent service.'
    },
    {
      id: '43',
      name: 'kabeer goel',
      rating: 5,
      text: 'Awesome. Polite gentlemen'
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  // const calculateAverageRating = () => {
  //   const total = reviews.reduce((sum, review) => sum + review.rating, 0);
  //   return (total / reviews.length).toFixed(1);
  // };

  return (
    <section id="reviews" className="reviews-section">
      <div className="container">
        {/* <div className="reviews-header">
          <h1>Client Reviews & Testimonials</h1>
          <div className="reviews-summary">
            <div className="rating-overview">
              <div className="average-rating">
                <span className="rating-number">{calculateAverageRating()}</span>
                <div className="stars-display">
                  {renderStars(5)}
                </div>
                <span className="review-count">({reviews.length} reviews)</span>
              </div>
            </div>
            <p className="reviews-intro">
              See what our clients say about their experience with our professional notary services. 
              Every review represents real clients who have trusted us with their important documents.
            </p>
          </div>
        </div> */}

        <div className="reviews-grid">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              
              <div className="review-header">
                <div className="reviewer-info">
                  <div className="reviewer-avatar">
                    {review.name.charAt(0).toUpperCase()}
                  </div>
                  <div className="reviewer-details">
                    <h3 className="reviewer-name">{review.name}</h3>
                  </div>
                </div>
                <div className="review-meta">
                  <div className="review-rating">
                    {renderStars(review.rating)}
                  </div>
                </div>
              </div>

              <div className="review-content">
                <p>{review.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="reviews-cta">
          <h3>Ready to Experience Our Professional Service?</h3>
          <p>Join hundreds of satisfied clients who trust us with their notary needs.</p>
          <div className="cta-buttons">
            <HashLink to="/#contact" smooth className="btn btn-primary">Book Appointment</HashLink>
            <a href="tel:+14374490147" className="btn btn-outline" style={{ color: 'var(--primary-600)', borderColor: 'var(--primary-600)' }}>Call Now</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;